import React, { useEffect, useContext } from 'react';

import ResultsComponent from '../../../../components/ResultsComponent';

import { CalculatorNavigationContext } from '../../../../contexts/CalculatorNavigationProvider';
import { InfusionWithoutAdditiveContext } from '../../../../contexts/InfusionProvider/InfusionWithoutAdditiveProvider';
import { ResultsContext } from '../../../../contexts/ResultsProvider';

interface InfusionWithoutAdditiveResultScreenProps {
 description?: string;
}

function InfusionWithoutAdditiveResultScreen({
 description,
}: InfusionWithoutAdditiveResultScreenProps): React.ReactElement {
 const {
  setNextButtonAction,
  setNextButtonText,
  setBackButtonText,
  setBackButtonAction,
 } = useContext(CalculatorNavigationContext);

 const { secondScreenRedirect, homeRedirect } = useContext(
  InfusionWithoutAdditiveContext,
 );

 const { setHasMultipleResults, setResultArray } = useContext(ResultsContext);

 const setNavigationProps = () => {
  const setNextButtonProps = () => {
   setNextButtonAction(homeRedirect);
   setNextButtonText('Ferdig');
  };
  const setBackButtonProps = () => {
   setBackButtonText('Forrige');
   setBackButtonAction(secondScreenRedirect);
  };
  setNextButtonProps();
  setBackButtonProps();
 };

 const setResultProps = () => {
  setHasMultipleResults(true);
  setResultArray([
   { description: 'Mengde' },
   { description: 'Hastighet' },
   { description: 'Hastighet' },
   { description: 'Hastighet' },
   { description: 'Hastighet' },
   { description: 'Hastighet' },
  ]);
 };

 useEffect(() => {
  setNavigationProps();
  setResultProps();
  // eslint-disable-next-line react-hooks/exhaustive-deps
 }, []);

 return <ResultsComponent description={description} />;
}

InfusionWithoutAdditiveResultScreen.defaultProps = {
 description: 'Mengde',
};

export default InfusionWithoutAdditiveResultScreen;
